'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionLabel = getOptionLabel;
exports.getOptionValue = getOptionValue;
function isStringFormat(quickReplyOption) {
  return typeof quickReplyOption === 'string';
}

function getOptionLabel(quickReplyOption) {
  if (isStringFormat(quickReplyOption)) {
    return quickReplyOption;
  }

  if (!quickReplyOption.has('label')) {
    return quickReplyOption.get('value');
  }

  return quickReplyOption.get('label');
}

function getOptionValue(quickReplyOption) {
  return isStringFormat(quickReplyOption) ? quickReplyOption : quickReplyOption.get('value');
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/models/QuickReplyModel.js
// module id = 1128
// module chunks = 2 3